import SystemModal from "../Common/SystemModal";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import Select from "react-select";
import ajaxStations from "../../util/remote/ajaxStations";
import ajaxFuelPumps from "../../util/remote/ajaxFuelPumps";
const UpdateStationModal = (props) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [Pumpcode, setPumpcode] = useState("");
  // Form fields
  const [stationID, setStationID] = useState("");

  // Lists
  const [stations_list, setStationsList] = useState([]);
  // Populate form when modal opens
  useEffect(() => {
    if (props.data) {
      const data = props.data;
      setStationID(data.station_id || "");
      setPumpcode(data.pump_code || "");
    }
  }, [props.data]);
  // Fetch stations
  const fetchStations = async () => {
    setLoading(true);
    const response = await ajaxStations.liststations_mini_data();
    if (response.status === "OK") {
      const list =
        Array.isArray(response.details) &&
        response.details.map((d) => ({
          value: d.id,
          label: d.station_name,
        }));
      setStationsList(list);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStations();
  }, []);
  // Validation
  const allRowsFilled = () => stationID && Pumpcode;
  // Update handler
  const handleUpdate = async (e, closeModal) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const payload = {
      id: props.data.id,
      station_id: stationID,
      pump_code: Pumpcode,
    };
    setLoading(true);
    const response = await ajaxFuelPumps.update_Pumps(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func(); // refresh parent data
      setTimeout(() => closeModal(), 2000);
    } else {
      toast.error(response.message);
    }
  };
  // Footer buttons
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleUpdate(e, controls.close)}
        disabled={loading || !allRowsFilled()}
      >
        {loading ? "Updating..." : "Update Tank"}
      </button>
    </>
  );
  return (
    <SystemModal title="Update Fuel Category" size="md" footer={RenderFooter}>
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Update Fuel Tank</h6>
                <form onSubmit={(e) => handleUpdate(e, () => {})}>
                  <div className="row mb-3">
                    {/* Station */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Select Station <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={stations_list}
                        value={stations_list.find(
                          (item) =>
                            item.value.toString() === stationID?.toString()
                        )}
                        onChange={(selected) => setStationID(selected.value)}
                        isDisabled={true} // cannot change station
                        placeholder="Select station"
                      />
                    </div>
                    {/* Fuel Category */}

                    {/* Pump Code */}
                    <div className="col-md-12 mb-3">
                      <label>
                        Fuel Pump Code <span style={{ color: "red" }}>*</span>
                      </label>

                      <input
                        type="text"
                        value={Pumpcode}
                        onChange={(e) => setPumpcode(e.target.value)}
                        className="form-control"
                        placeholder="Enter pump code, e.g Est001A"
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default UpdateStationModal;
